import React from "react";
import { Link } from "react-router-dom";

// Drawn rather than typed, so it is big enough to see. It points down, as
// the company invoice opens fields underneath; the gift link turns it to
// point right, as that goes to another page.
const Chevron = ({ className = "" }) => (
  <svg className={`chevron ${className}`.trim()} viewBox="0 0 16 16" aria-hidden="true">
    <path
      d="M4 6l4 4 4-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SpecialOptions = ({
  showCompanyForm,
  onChangeShowCompanyForm,
  giftLink,
}) => {
  return (
    <>
      {giftLink && (
        <Link
          to="/gift"
          className="special-option-btn"
          type="button"
          id="giftBtn"
          aria-controls="giftFields"
        >
          <svg aria-hidden="true">
            <use href="#icon-gift" />
          </svg>
          Buying this for someone else?
          <Chevron className="chevron--right" />
        </Link>
      )}

      {giftLink && (
        <div className="special-option-divider" id="giftDivider"></div>
      )}
      <button
        className="special-option-btn"
        type="button"
        id="invoiceBtn"
        onClick={() => onChangeShowCompanyForm()}
        aria-expanded={showCompanyForm}
        aria-controls="invoiceFields"
      >
        <svg aria-hidden="true">
          <use href="#icon-invoice" />
        </svg>{" "}
        I need a company invoice
        <Chevron className={showCompanyForm ? "open" : ""} />
      </button>
    </>
  );
};

export default SpecialOptions;
